import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const Home = r => require.ensure([], () => r(require('@/page/Home')), 'Home');
const HomeJump = r => require.ensure([], () => r(require('@/page/HomeJump')), 'Home');
const Login = r => require.ensure([], () => r(require('@/page/login')), 'Home');
const Page404 = r => require.ensure([], () => r(require('@/page/404')), 'Home');
const Page500 = r => require.ensure([], () => r(require('@/page/500')), 'Home');
const Benefits = r => require.ensure([], () => r(require('@/page/other/referral')), 'Home');
const Disable = r => require.ensure([], () => r(require('@/page/disable')), 'Home');

const Unsubscribe = r => require.ensure([], () => r(require('@/page/other/Unsubscribe')), 'Other');
const Sleak = r => require.ensure([], () => r(require('@/page/other/Sleak')), 'Other');
const Service = r => require.ensure([], () => r(require('@/page/other/Service')), 'Other');
const Legal = r => require.ensure([], () => r(require('@/page/other/Legal')), 'Other');
const Privacy = r => require.ensure([], () => r(require('@/page/other/Privacy')), 'Other');
const About = r => require.ensure([], () => r(require('@/page/other/About')), 'Other');
const Career = r => require.ensure([], () => r(require('@/page/other/Career')), 'Other');
const Career1 = r => require.ensure([], () => r(require('@/page/other/Careerdetail')), 'Other');
const Career2 = r => require.ensure([], () => r(require('@/page/other/Careerdetail1')), 'Other');
const Career3 = r => require.ensure([], () => r(require('@/page/other/Careerdetail2')), 'Other');
const Career4 = r => require.ensure([], () => r(require('@/page/other/Careerdetail3')), 'Other');
const Contact = r => require.ensure([], () => r(require('@/page/other/Contact')), 'Other');
const Exchangeintro = r => require.ensure([], () => r(require('@/page/other/ExchangeDisable')), 'Other');
const BorrowDisable = r => require.ensure([], () => r(require('@/page/borrow/BorrowDisable')), 'Other');
const depositintro = r => require.ensure([], () => r(require('@/page/other/DepositDisable')), 'Other');
const cookiePolicy = r => require.ensure([], () => r(require('@/page/other/CookiePolicy')), 'Other');
const Globalcoin = r => require.ensure([], () => r(require('@/page/other/Globalcoin')), 'Other');
const Techcrunch = r => require.ensure([], () => r(require('@/page/activity/Techcrunch')), 'Other');

const Forgotpass = r => require.ensure([], () => r(require('@/page/onboarding/Forgotpass')), 'OnBoard');
const Verifyemail = r => require.ensure([], () => r(require('@/page/onboarding/Verifyemail')), 'OnBoard');
const Resetpass = r => require.ensure([], () => r(require('@/page/onboarding/Resetpass')), 'OnBoard');
const Register = r => require.ensure([], () => r(require('@/page/Register')), 'OnBoard');
const Verifyyouremail = r => require.ensure([], () => r(require('@/page/onboarding/Verifyyouremail')), 'OnBoard');
const VerifyyouremailLink = r => require.ensure([], () => r(require('@/page/onboarding/VerifyyouremailLink')), 'OnBoard');
const Finish = r => require.ensure([], () => r(require('@/page/onboarding/Finish')), 'OnBoard');
const AddPhoneNum = r => require.ensure([], () => r(require('@/page/onboarding/AddPhoneNum')), 'OnBoard');
const PersonalDetail = r => require.ensure([], () => r(require('@/page/onboarding/PersonalDetail')), 'OnBoard');
const Kba = r => require.ensure([], () => r(require('@/page/onboarding/Kba')), 'OnBoard');
const UploadInfo = r => require.ensure([], () => r(require('@/page/onboarding/UploadInfo')), 'OnBoard');
const UploadAlone = r => require.ensure([], () => r(require('@/page/onboarding/UploadAlone')), 'OnBoard');
const KycSsn = r => require.ensure([], () => r(require('@/page/onboarding/KycSsn')), 'OnBoard');
const BindSsn = r => require.ensure([], () => r(require('@/page/onboarding/BindSsn')), 'OnBoard');
const AddEmail = r => require.ensure([], () => r(require('@/page/onboarding/AddEmail')), 'OnBoard');
const SelectCountry = r => require.ensure([], () => r(require('@/page/onboarding/SelectCountry')), 'OnBoard');
const PersonAddress =r => require.ensure([],()=>r(require('@/page/onboarding/PersonAddress')),'OnBoard');
const Citizenship= r => require.ensure([],()=>r(require('@/page/onboarding/Citizenship')),'OnBoard');
const SocialSecurityNum =r => require.ensure([],()=>r(require('@/page/onboarding/SocialSecurityNum')),'OnBoard');
const Verifyyouridentity = r => require.ensure([],()=>(require('@/page/onboarding/Verifyyouridentity')),'OnBoard')

const Profile = r => require.ensure([], () => r(require('@/page/settings/Profile')), 'Setting');
const Security = r => require.ensure([], () => r(require('@/page/settings/Security')), 'Setting');
const AccountLimits = r => require.ensure([], () => r(require('@/page/settings/AccountLimits')), 'Setting');
const Address = r => require.ensure([], () => r(require('@/page/settings/Address')), 'Setting');
const Addressdetail = r => require.ensure([], () => r(require('@/page/settings/Addressdetail')), 'Setting');
const Application = r => require.ensure([], () => r(require('@/page/settings/Application')), 'Setting');
const ChangePassword = r => require.ensure([], () => r(require('@/page/settings/ChangePassword')), 'Setting');
const ConfirmedDevices = r => require.ensure([], () => r(require('@/page/settings/ConfirmedDevices')), 'Setting');
const Protection = r => require.ensure([], () => r(require('@/page/settings/Protection')), 'Setting');
const SendEmailSuccess = r => require.ensure([], () => r(require('@/page/settings/SendEmailSuccess')), 'Setting');
const Deviceverify = r => require.ensure([], () => r(require('@/page/settings/Deviceverify')), 'Setting');

const AccountBank = r => require.ensure([], () => r(require('@/page/settings/AccountBank')), 'Bank');
const BankJump = r => require.ensure([], () => r(require('@/page/settings/BankJump')), 'Bank');
const AccountBankAdd = r => require.ensure([], () => r(require('@/page/settings/AccountBankAdd')), 'Bank');
const AccountBankDetail = r => require.ensure([], () => r(require('@/page/settings/AccountBankDetail')), 'Bank');
const AddFastWire = r => require.ensure([], () => r(require('@/page/settings/AddFastWire')), 'Bank');
const AddCreditAccount = r => require.ensure([], () => r(require('@/page/settings/AddCreditAccount')), 'Bank');

const Mint = r => require.ensure([], () => r(require('@/page/mint/Mint')), 'Mint');
const MintHome = r => require.ensure([], () => r(require('@/page/mint/MintHome')), 'Mint');
const MintLegal = r => require.ensure([], () => r(require('@/page/mint/MintLegal')), 'Mint');
const MintOrder = r => require.ensure([], () => r(require('@/page/mint/MintOrder')), 'Mint');
const MintHistory = r => require.ensure([], () => r(require('@/page/mint/MintHistory')), 'Mint');
const MintDetail = r => require.ensure([], () => r(require('@/page/mint/MintDetail')), 'Mint');

const Deposit = r => require.ensure([], () => r(require('@/page/termdeposit/Deposit')), 'Accounts');
const Dashboard = r => require.ensure([], () => r(require('@/page/account/Dashboard')), 'Accounts');
const Ssn = r => require.ensure([], () => r(require('@/page/account/Ssn')), 'Accounts');

const Exchange = r => require.ensure([], () => r(require('@/page/trade/Exchange')), 'Exchange');

const Borrow = r => require.ensure([], () => r(require('@/page/borrow/Borrow')), 'Borrow');
const sign = r => require.ensure([], () => r(require('@/page/borrow/sign')), 'Borrow');

const VerificationSMS = r => require.ensure([], () => r(require('@/page/settings/VerificationSMS')), 'Home');
const VerificationEmail = r => require.ensure([], () => r(require('@/page/settings/VerificationEmail')), 'Home');
const VerificationOTG = r => require.ensure([], () => r(require('@/page/settings/VerificationOTG')), 'Home');
const Factor = r => require.ensure([], () => r(require('@/page/settings/Factor')), 'Home');
const InformationCofirm = r => require.ensure([], () => r(require('@/page/other/InformationCofirm')), 'Home');
const Referral = r => require.ensure([], () => r(require('@/page/activity/Referral')), 'Activity');



export default new Router({
  mode: 'history',
  base:'secure',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/referral',
      name: 'referral',
      component: Referral,
    },
    {
      path: '/informationCofirm',
      name: 'InformationCofirm',
      component: InformationCofirm
    },
    {
      path: '/homeJump',
      name: 'HomeJump',
      component: HomeJump
    },
    {
      path: '/bankJump',
      name: 'bankJump',
      component: BankJump
    },
    {
      path: '/sleak',
      name: 'sleak',
      component: Sleak
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/unsubscribe',
      name: 'unsubscribe',
      component: Unsubscribe,
    },
    {
      path: '/factor',
      name: 'factor',
      component: Factor,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/activity/techcrunch',
      name: 'techcrunch',
      component: Techcrunch,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/exchange',
      name: 'Exchange',
      component: Exchange,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/Borrow',
      name: 'Borrow',
      component: Borrow,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/application',
      name: 'application',
      component: Application,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/changepassword',
      name: 'changepassword',
      component: ChangePassword,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/protection',
      name: 'protection',
      component: Protection,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/sendemailsuccess',
      name: 'sendemailsuccess',
      component: SendEmailSuccess,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/deviceverify',
      name: 'deviceverify',
      component: Deviceverify,
    },

    {
      path: '/confirmedDevices',
      name: 'confirmedDevices',
      component: ConfirmedDevices,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/verificationSMS',
      name: 'verificationSMS',
      component: VerificationSMS,
    },
    {
      path: '/verificationEmail',
      name: 'verificationEmail',
      component: VerificationEmail,
    },
    {
      path: '/verificationOTG',
      name: 'verificationOTG',
      component: VerificationOTG,
    },
    {
      path: '/page500',
      name: 'page500',
      component: Page500
    },
    {
      path: '/career',
      name: 'career',
      component: Career
    },
    {
      path: '/career1',
      name: 'career1',
      component: Career1
    },
    {
      path: '/career2',
      name: 'career2',
      component: Career2
    },
    {
      path: '/career3',
      name: 'career3',
      component: Career3
    },
    {
      path: '/career4',
      name: 'career4',
      component: Career4
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/forgotpass',
      name: 'forgotpass',
      component: Forgotpass
    },
    {
      path: '/finish',
      name: 'finish',
      component: Finish
    },
    {
      path: '/AddPhoneNum',
      name: 'addPhoneNum',
      component: AddPhoneNum,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/uploadInfo',
      name: 'uploadInfo',
      component: UploadInfo,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/uploadalone',
      name: 'uploadalone',
      component: UploadAlone,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/personalDetail',
      name: 'personalDetail',
      component: PersonalDetail,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/kba',
      name: 'kba',
      component: Kba,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/resetpass',
      name: 'resetpass',
      component: Resetpass
    },
    {
      path: '/verifyemail',
      name: 'verifyemail',
      component: Verifyemail
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/AddEmail',
      name: 'AddEmail',
      component: AddEmail
    },
    {
        path: '/SelectCountry',
        name: 'SelectCountry',
        component: SelectCountry
    },
    {
        path: '/PersonAddress',
        name: 'PersonAddress',
        component: PersonAddress
    },
    {
        path: '/Citizenship',
        name: 'Citizenship',
        component: Citizenship
    },
    {
        path: '/SocialSecurityNum',
        name: 'SocialSecurityNum',
        component: SocialSecurityNum
    },
    {
        path: '/Verifyyouridentity',
        name: 'Verifyyouridentity',
        component: Verifyyouridentity
    },
    {
      path: '/verifyyouremail',
      name: 'verifyyouremail',
      component: Verifyyouremail
    },
    {
      path: '/verifyyouremaillink',
      name: 'verifyyouremaillink',
      component: VerifyyouremailLink
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/security',
      name: 'security',
      component: Security,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/accountlimits',
      name: 'accountlimits',
      component: AccountLimits,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/accountBank',
      name: 'accountBank',
      component: AccountBank,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/accountBankAdd',
      name: 'accountBankAdd',
      component: AccountBankAdd,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/addCreditAccount',
      name: 'addCreditAccount',
      component: AddCreditAccount,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/AddFastWire',
      name: 'AddFastWire',
      component: AddFastWire,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/accountBankDetail',
      name: 'accountBankDetail',
      component: AccountBankDetail,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/address',
      name: 'address',
      component: Address,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/addressdetail',
      name: 'addressdetail',
      component: Addressdetail,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/service',
      name: 'Service',
      component: Service
    },
    {
      path: '/legal',
      name: 'legal',
      component: Legal
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy
    },
    {
      path: '/cookiepolicy',
      name: 'cookiepolicy',
      component: cookiePolicy
    },
    {
      path: '/deposit',
      name: 'Deposit',
      component: Deposit,
      meta: {
        requireAuth: true,
        availableCheck: true,
        toPage: '/disable',
        cfg: 'TermDeposit',
      },
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requireAuth: true,
      },
      children:[
        {
            path:"/minthistory",
            name:"minthistory",
            component:MintHistory
        },
        {
            path:"/mintdetail",
            name:"mintdetail",
            component:MintDetail
        }
    ]
    },
    {
      path: '/benefits',
      name: 'benefits',
      component: Benefits,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/disable',
      name: 'disable',
      component: Disable,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/depositintro',
      name: 'depositintro',
      component: depositintro
    },
    {
      path: '/exchangeintro',
      name: 'exchangeintro',
      component: Exchangeintro,
    },
    {
      path: '/borrowintro',
      name: 'borrowdisable',
      component: BorrowDisable,
    },
    {
      path: '/sign',
      name: 'sign',
      component: sign,
    },
    {
      path: '/ssn',
      name: 'ssn',
      component: Ssn,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/kycssn',
      name: 'kycssn',
      component: KycSsn,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/bindssn',
      name: 'bindssn',
      component: BindSsn,
    },
    {
        path:'/mint',
        name:'mint',
        component:Mint,
        redirect:"minthome",
        children:[
        {
            path:"/minthome",
            name:"minthome",
            component:MintHome
        },{
            path:"/mintOrder",
            name:"mintOrder",
            component:MintOrder
        },{
            path:"/mintLegal",
            name:"mintLegal",
            component:MintLegal
        }]
    },
    {
      path: '/libra',
      name: 'globalcoin',
      component: Globalcoin,
    },
    {
      path: '*', // 此处需特别注意至于最底部
      name: 'Page404',
      component: Page404
    }
  ]
})






// WEBPACK FOOTER //
// ./src/router/index.js